import { useCallback, memo } from 'react'
import AsyncSelect from 'react-select/async'

import { FilteredType } from './viewSelectModalVariable.filters.component'

interface SelectItemFilterProps {
  options: FilteredType[]
  placeholder?: string
  isLoading: boolean
  addToExpression: (expression: FilteredType) => void
  value: string
}

const SelectItemFilter = memo(
  ({ options, placeholder, isLoading, addToExpression, value }: SelectItemFilterProps) => {
    const loadOptions = useCallback(
      (inputValue: string, callback: (options: FilteredType[]) => void) => {
        const filteredOptions = options?.filter(
          option => option.label && option.label.toLowerCase().includes(inputValue.toLowerCase()),
        )
        callback(filteredOptions)
      },
      [options],
    )

    const sendElement = (option: FilteredType) => {
      addToExpression(option)
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={options}
        loadOptions={loadOptions}
        onChange={option => {
          sendElement(option as FilteredType)
        }}
        placeholder={value || placeholder}
        styles={{
          control: baseStyles => ({
            ...baseStyles,
            width: '150px',
            minHeight: '32px',
            fontSize: '0.9rem',
            cursor: 'pointer',
            '@media (max-width: 768px)': {
              width: '100%',
            },
          }),
          valueContainer: baseStyles => ({
            ...baseStyles,
            maxHeight: '30px',
            padding: '0 6px',
          }),
          input: baseStyles => ({
            ...baseStyles,
            fontSize: '0.9rem',
          }),
          placeholder: baseStyles => ({
            ...baseStyles,
            fontSize: '0.9rem',
          }),
          singleValue: baseStyles => ({
            ...baseStyles,
            fontSize: '0.9rem',
          }),
          option: baseStyles => ({
            ...baseStyles,
            fontSize: '0.9rem',
          }),
          menuList: baseStyles => ({
            ...baseStyles,
            maxHeight: '150px',
            overflowX: 'hidden',
          }),
        }}
        noOptionsMessage={() => 'Sem resultados'}
        isLoading={isLoading}
        isDisabled={Boolean(value)}
        menuShouldScrollIntoView={false}
      />
    )
  },
)

export default SelectItemFilter
